import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { BehaviorSubject, of, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TalkToDoctorService {
  backendUrl = `${environment.restAPIUrl}/api/public`;

  address_demo = [
    {
      id:1,
      serviceStorename: `Radhaa's Ayurway - A multi speciality family wellness centre`,
      addressDetails: `1st floor, NPM Associates, Durga nagar, Markandeya colony, Town: Godavarikhani, Mandal: Ramagundam, Dist: Peddapalli, 
      State: Telangana, Pin code: 505209`,
      contactNo:'99669 33323, 087283 56222' , 
      email: 'frontoffice.GK@ayurway.com',
      mapUrl:`https://goo.gl/maps/Fkn4AhdcmcwdtYVH9`
    },
    {
      id: 2,
      serviceStorename: `Radhaa's Ayurway – Begin your wellness`,
      addressDetails: `3rd floor millenium square building, above Ratnadeep supermarket, Gachibowli, Telangana 500032`,
      contactNo:'91540 45404',
      email: '',
      mapUrl:`https://goo.gl/maps/QFmPgbGbNae2aXwbA`
    }
  ]

  appointment$ = new BehaviorSubject(null)
  constructor(private http: HttpClient) { }
  setAppointment(appointmentObj: any) {
    this.appointment$.next(appointmentObj);
  };

  getServiceAddress(){
    return this.http.get(`${this.backendUrl}/getServiceLocationDetails`)
    // return of(this.address_demo)
  }

  //booking services api

  postServiceData(obj) {
    return this.http.post(`${this.backendUrl}/bookService`, obj);
  }

  getAppointment() {
    return this.appointment$.asObservable();
  };
  clearToken() {
    this.appointment$.next(null);
  };
  getCity() {
    return this.http.get(`${this.backendUrl}/getCities`)
  };

  getSearch(value: any) {
    return this.http.get(`${this.backendUrl}/getAutoSuggestionForSearch?searchText=${value}`)
  };

  getDoctorList(obj: any) {
    return this.http.post(`${this.backendUrl}/searchDoctors`, obj);
  };

  getGender() {
    return this.http.get(`${this.backendUrl}/genders`);
  };
  getmemberDetails() {
    return this.http.get(`${environment.restAPIUrl}/api/members/getMemberDetails`);
  };

  postRequestAppoinment(data: any) {
    return this.http.post(`${environment.restAPIUrl}/api/members/bookAppointment`, data);
  }

  myAppoinmentList(data: any) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getAllAppointments`, data)
  };

  upcomingAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getUpcomingAppointments`, data)
  };
  cancalAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getCancelAppointments`, data)
  };
  rejectAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getRejectedAppointments`, data)

  };
  claimAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getClaimedAppointments`, data)
  };
  reqToClaim(req) {
    return this.http.post(`${environment.restAPIUrl}/api/members/claimAppointment`, req)

  }
  reqJoinVideo(id) {
    return this.http.get(`${environment.restAPIUrl}/api/members/joinRoom?appointmentId=${id}`);
  };

  cancelAppointment(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/cancelAppointment`, obj);
  };


  memberAppointment_Status(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/actionAppointment`, obj);
  }

  makePaymentOfAppointment(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/makePayment`, obj);
  }

  confirmPayment(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/confirmPayment`, obj);
  }

  bookingScheduler(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getAppointmentSlot`, obj);
  };

  appointmentDetails(id) {
    return this.http.post(`${environment.restAPIUrl}/api/members/getAppointmentById`, id);
  };

  payOnPoints(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/members/makePaymentByPoints`, obj);
  }

  downloadFile(id) {
    return this.http.get(`${environment.restAPIUrl}/api/members/getAppointmentFile?fileId=${id.fileId}`, { responseType: 'blob' });
  };

  //member reschdule
  memberRescheduleAppointment(req) {
    return this.http.post(`${environment.restAPIUrl}/api/members/slotreschedule`, req);
  };

  refundAmount(req) {
    return this.http.post(`${environment.restAPIUrl}/api/members/refundAppointment`, req);
  }

  //doctors Apis;
  DoctorsAppoint_lists(data: any) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getAllAppointment`, data);
  };
  doctorApprove(data: any) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/appointmentAction`, data);
  }
  DoctorJoinVideo(id) {
    return this.http.get(`${environment.restAPIUrl}/api/doctor/joinRoom?appointmentId=${id}`);
  }
  createAppointmentToMember(data: any) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/bookAppointmentForMember`, data);
  };

  rescheduleAppointment(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/rescheduleAppointment`, data);
  };
  DoctorBookingScheduler(obj) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getAppointmentSlot`, obj);
  };
  doctorAppointmentDetails(id) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getAppointmentById`, id);
  };
  downloadDoctorFile(id) {
    return this.http.get(`${environment.restAPIUrl}/api/doctor/getAppointmentFile?fileId=${id.fileId}`, { responseType: 'blob' });
  }

  getAppointmentsOnDates(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getAllAppointmentsByDate`, data);
  };

  upcomingDocAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getUpcomingAppointments`, data)
  };
  cancalDocAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getCancelAppointments`, data)
  };
  rejectDocAppList(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/getRejectedAppointments`, data)

  };
  takeNote(data) {
    return this.http.post(`${environment.restAPIUrl}/api/doctor/writeNote`, data)
  }






}
